<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <p
          [innerHtml]="
            isHostedEnabled
              ? ('tkey;admin.license.description.header_zpm' | escapeHtml)
              : ('tkey;admin.license.description.header_zpc' | escapeHtml)
          "
        ></p>
        <p
          [innerHtml]="
            isHostedEnabled
              ? ('tkey;admin.license.description.text.hosted_true' | escapeHtml)
              : ('tkey;admin.license.description.text.hosted_false' | escapeHtml)
          "
          class="mb-0"
        ></p>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @if (licenseStatusMessage.title) {
      <div
        [ngClass]="{
          'alert-warning': licenseHealthStatus.state === state.WARNING,
          'alert-danger': licenseHealthStatus.state === state.ERROR,
        }"
        class="alert"
        data-automation="license-alert"
      >
        <h4>{{ licenseStatusMessage.title | translate }}</h4>
        <div [innerHTML]="licenseStatusMessage.content | escapeHtml"></div>
      </div>
    }

    <div class="col-sm-12 p-0">
      @if (!isLoading && licenseStatusCause !== 'No license installed') {
        <div>
          <table class="table mb-4 table-striped" data-automation="license-details">
            <tbody>
              <tr
                [ngClass]="{
                  'bg-info': licenseHealthStatus?.state === state.OK,
                  'bg-danger': licenseHealthStatus?.state === state.ERROR,
                  'bg-warning': licenseHealthStatus?.state === state.WARNING,
                }"
              >
                <th colspan="2" class="text-white">
                  {{ 'tkey;admin.license.module.license_details.text' | translate }}
                </th>
              </tr>
              <tr>
                <td>
                  <strong>{{ 'tkey;admin.license.company.text' | translate }}</strong>
                </td>
                <td class="text-end" data-automation="license-company">
                  <code>{{ licenseInfo?.company }}</code>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{{ 'tkey;admin.license.total_licenses.text' | translate }}</strong>
                </td>
                <td class="text-end" data-automation="license-total">
                  <code>{{ licenseInfo?.totalLicenses }}</code>
                </td>
              </tr>
              <tr
                data-automation="license-used-wrapper"
                [class.table-warning]="licenseStatusCause === 'Exceeded number of licenses'"
              >
                <td>
                  <strong>{{ 'tkey;admin.license.used_licenses.text' | translate }}</strong>
                </td>
                <td class="text-end" data-automation="license-used">
                  <code>{{ licenseInfo?.totalUsedLicenses }}</code>
                </td>
              </tr>
              <tr
                data-automation="license-expiry-date-wrapper"
                [class.table-danger]="licenseStatusCause === 'License is expired'"
              >
                <td>
                  <strong>{{ 'tkey;admin.license.expiry_date.text' | translate }}</strong>
                </td>
                <td class="text-end" data-automation="license-expiry-date">
                  @if (licenseInfo?.expiryDate) {
                    <code>{{ licenseInfo?.expiryDate }}</code>
                  }
                  @if (!licenseInfo?.expiryDate) {
                    <code>
                      {{ 'tkey;admin.license.expiry_date.perpetual.text' | translate }}
                    </code>
                  }
                </td>
              </tr>
            </tbody>
          </table>
          @if (!isHostedEnabled) {
            <table class="table mb-4 table-striped" data-automation="license-ziro-modules">
              <tbody>
                <tr class="bg-info">
                  <th colspan="2" class="text-white">{{ 'tkey;admin.license.module.text' | translate }}</th>
                </tr>
                <tr
                  ziro-license-module-row
                  data-automation="license-ziro-enabled"
                  [moduleEnabled]="licenseInfo?.modules.provisioning"
                  [moduleName]="'tkey;admin.license.module.manage.text'"
                ></tr>
                <tr
                  ziro-license-module-row
                  data-automation="license-zero-touch-enabled"
                  [moduleEnabled]="licenseInfo?.modules.automation"
                  [moduleName]="'tkey;admin.license.module.automation.text'"
                ></tr>
                <tr
                  ziro-license-module-row
                  data-automation="license-reports-enabled"
                  [moduleEnabled]="licenseInfo?.modules.reporting"
                  [moduleName]="'tkey;admin.license.module.reports.text'"
                ></tr>
                <tr
                  ziro-license-module-row
                  data-automation="license-high-availability-enabled"
                  [moduleEnabled]="licenseInfo?.modules.highAvailability"
                  [moduleName]="'tkey;admin.license.module.high_availability.text'"
                ></tr>
                <tr
                  ziro-license-module-row
                  data-automation="license-migrate-to-teams-enabled"
                  [moduleEnabled]="licenseInfo?.modules.proxyServerOnlyMode"
                  [moduleName]="'tkey;admin.license.module.proxy_server.text'"
                ></tr>
              </tbody>
            </table>
          }
          @if (!isHostedEnabled && licenseInfo?.consumedCucmLicenseCountBreakdown?.length >= 2) {
            <table class="table mb-4 table-striped" data-automation="detailed-license-usage">
              <tbody>
                <tr class="bg-info">
                  <th colspan="2" class="text-white">
                    {{ 'tkey;admin.license.detailed_license_usage.text' | translate }}
                  </th>
                </tr>
                @for (ciscoUsage of cucmLicenseUsage; track trackByName($index, ciscoUsage)) {
                  <tr data-automation="license-detail-cisco-row">
                    <td data-automation="license-detail-cisco-row-name">
                      <strong>{{ ciscoUsage.cucmDescription }}</strong>
                    </td>
                    <td data-automation="license-detail-cisco-row-count" class="text-end">
                      <strong>{{ ciscoUsage.totalLicenses }}</strong>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
          <br />
        </div>
      }
      <ziro-file-upload [fieldId]="'licenseFileUpload'"></ziro-file-upload>
    </div>
  </div>
</div>

<ziro-bottom-nav data-automation="license-import-button"></ziro-bottom-nav>
